import React from "react";

import FilterChip from "js/components/Dashboard/FilterChip";

type TenantFilters = {
  is_active?: string;
  status?: string;
  legal_type?: string;
};

interface TenantReportFiltersProps {
  onFilterChange: (filters: TenantFilters) => void;
  filters: TenantFilters;
}

const TenantReportFilters: React.FC<TenantReportFiltersProps> = ({
  onFilterChange,
  filters,
}) => {
  const handleFilterChange = (key: keyof TenantFilters, value?: string) => {
    const newFilters: TenantFilters = { ...filters };
    if (value == null || value === "") {
      delete newFilters[key];
    } else {
      newFilters[key] = value;
    }
    onFilterChange(newFilters);
  };

  return (
    <div className="flex flex-wrap gap-2">
      <FilterChip
        label="Estado"
        value={filters.is_active}
        onChange={(value) => handleFilterChange("is_active", value)}
        options={[
          { label: "Activo", value: "true" },
          { label: "Inactivo", value: "false" },
        ]}
      />

      <FilterChip
        label="Fase"
        value={filters.status}
        onChange={(value) => handleFilterChange("status", value)}
        options={[
          { label: "Iniciado", value: "1" },
          { label: "Pago Pendiente", value: "2" },
          { label: "En progreso", value: "3" },
          { label: "Completado", value: "4" },
        ]}
      />

      <FilterChip
        label="Tipo"
        value={filters.legal_type}
        onChange={(value) => handleFilterChange("legal_type", value)}
        options={[
          { label: "Persona Física", value: "1" },
          { label: "Persona Moral", value: "2" },
        ]}
      />
    </div>
  );
};

export default TenantReportFilters;
